import { TooltipV2 } from "@/components/TooltipV2";
import { IconButtonV2, IconButtonV2Props } from "@/components/interactive/ButtonV2";
import { classNames } from "@/utils/classnames";
import React, { ReactNode, forwardRef } from "react";

type ToolbarIconButtonV2Props = Omit<IconButtonV2Props, "variant"> & {
  tooltip?: ReactNode;
};

const ToolbarIconButtonV2Base = forwardRef<HTMLButtonElement, ToolbarIconButtonV2Props>(
  function ToolbarIconButtonV2Impl({ className, iconSize, size = "sm", tooltip, ...props }, ref) {
    const button = (
      <IconButtonV2
        ref={ref}
        size={size}
        iconSize={iconSize ?? (size === "sm" ? "md" : undefined)}
        variant={"tertiary"}
        className={classNames(
          "!bg-transparent !text-cds-ink-subtle",
          "hover:!bg-cds-surface-border hover:!text-cds-ink-strong",
          "aria-expanded:!bg-cds-surface-border aria-expanded:!text-cds-ink-strong",
          "active:!bg-cds-surface-border",
          "[&_svg]:!text-cds-ink-subtle [&:hover_svg]:!text-cds-ink-strong aria-expanded:[&_svg]:!text-cds-ink-strong",
          "dark:!text-zinc-400 dark:hover:!bg-white/[0.08] dark:hover:!text-zinc-50",
          "dark:aria-expanded:!bg-white/[0.08] dark:aria-expanded:!text-zinc-50",
          "dark:[&_svg]:!text-zinc-400 dark:[&:hover_svg]:!text-zinc-50 dark:aria-expanded:[&_svg]:!text-zinc-50",
          className,
        )}
        {...props}
      />
    );

    if (tooltip == null) {
      return button;
    }

    return (
      <TooltipV2 content={tooltip} placement={"bottom"}>
        <span className={"inline-flex"}>{button}</span>
      </TooltipV2>
    );
  },
);

export const ToolbarIconButtonV2 = React.memo(ToolbarIconButtonV2Base);
ToolbarIconButtonV2.displayName = "ToolbarIconButtonV2";
